/**
 * Notify event keys.
 */
const NotifyEvents = {
    /*
     * Emitted when a subscription has been successfully added.
     * Payload is the section id.
     */
    added: "Notify.added",
    /*
     * Emitted when a bookmark is deleted.
     * Payload is the section id.
     */
    deleted: "Notify.deleted"
};

export default NotifyEvents;